var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMusic = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_note",
    "data-name": "icons/note",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 36,
    height: 36,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_music-note_2832887_000000",
    d: "M36.555,17.655a.956.956,0,0,0-.006-.135c-.007-.028-.027-.049-.036-.076a1.42,1.42,0,0,0-.214-.38,1,1,0,0,0-.531-.334,1.032,1.032,0,0,0-.226-.045c-.03,0-.055-.017-.084-.017a1.017,1.017,0,0,0-.137.027.957.957,0,0,0-.135.006l-9,2.25c-.028.007-.049.027-.076.036h0a1.053,1.053,0,0,0-.212.1,1.009,1.009,0,0,0-.5.645,1.083,1.083,0,0,0-.045.223c0,.031-.017.056-.017.086v8.082a3.332,3.332,0,0,0-1.125-.208,3.376,3.376,0,1,0,3.375,3.375V20.92l6.75-1.688v6.643a3.326,3.326,0,0,0-1.124-.208,3.375,3.375,0,1,0,3.375,3.375V17.792a1.023,1.023,0,0,0-.028-.137ZM24.208,32.418a1.125,1.125,0,1,1,1.125-1.125,1.125,1.125,0,0,1-1.125,1.125Zm9-2.25h0a1.125,1.125,0,1,1,1.124-1.125,1.125,1.125,0,0,1-1.124,1.125Z",
    transform: "translate(-10.708 -7.668)",
    fill: "#fff",
    stroke: "#312341",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMusic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/music.67f7417e.svg";
export { ForwardRef as ReactComponent };